import GfProduct from '@/gf/modules/Product'

export default { primaryImageURL: GfProduct.primaryImageURL }
